import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4 col-sm-12" }
const _hoisted_4 = { class: "list-group sticky-top" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-md-8 col-sm-12" }

import { format_date, format_price } from '@/helpers/filters'
import { onBeforeMount, reactive, ref, watch } from 'vue'
import { Cheque, ChequeLineItem, ListResponse, Paging, Uuid } from '@/types/api'
import { fillQueryParamsFromQueryString, objectsIsEquals, promoteParamsToSearch } from '@/helpers/tools'
import { silpoChequesApi } from '@/di/api'
import { useRouter } from "vue-router";
import SilpoProductInfoActions from "@/components/shopping/silpo/SilpoProductInfoActions.vue";
import AppPagination from "@/components/app/AppPagination.vue";
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";
import SilpoChequeListItem from "@/components/shopping/silpo/SilpoChequeListItem.vue";

interface Data {
  cheques: Cheque[],
  chequeLines: ChequeLineItem[],
  selectedChequeId: Uuid | undefined,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoChequeList',
  setup(__props) {

const router = useRouter()

const cheques = ref<ListResponse<Cheque>>({ items: [], total_count: 0 })
const data = reactive<Data>({ cheques: [], chequeLines: [], selectedChequeId: undefined })
const model = reactive<{ paging: Paging }>({ paging: { page: 1, per_page: 10 } })
const lock = reactive<{ isLoading: boolean }>({ isLoading: false })

watch(() => data.selectedChequeId, async (chequeId: Uuid | undefined): Promise<void> => {
  if (!chequeId) {
    return
  }

  lock.isLoading = true
  data.chequeLines = []

  try {
    data.chequeLines = (await silpoChequesApi.getChequeLines(chequeId)).items
  } finally {
    lock.isLoading = false
  }
})

watch(() => model.paging, async (current: Paging, prev: Paging): Promise<void> => {
  if (objectsIsEquals(current, prev)) {
    return
  }

  await loadCheques()
})

async function loadCheques (): Promise<void> {
  lock.isLoading = true

  try {
    const chequesData = await silpoChequesApi.getCheques(model)

    cheques.value = chequesData
    data.cheques = chequesData.items
    data.selectedChequeId = chequesData.items[0].id

    promoteParamsToSearch(model, router)
  } finally {
    lock.isLoading = false
  }
}

function onPageChanged (paging: Paging): void {
  model.paging = paging
}

function onListClick (id: string): void {
  data.selectedChequeId = id
}

onBeforeMount(async (): Promise<void> => {
  model.paging = fillQueryParamsFromQueryString({ paging: model.paging }).paging

  await loadCheques()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row", {'cursor-progress': lock.isLoading}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(AppPagination, {
            "total-count": cheques.value.total_count,
            page: model.paging.page,
            per_page: model.paging.per_page,
            disabled: lock.isLoading,
            onPageChanged: onPageChanged
          }, null, 8, ["total-count", "page", "per_page", "disabled"]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.cheques, (cheque) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `cheque-list-${cheque.id}`,
                class: _normalizeClass(["list-group-item cursor-pointer d-flex justify-content-between", { 'active': data.selectedChequeId === cheque.id, 'disabled': lock.isLoading }]),
                onClick: ($event: any) => (onListClick(cheque.id))
              }, [
                _createElementVNode("div", null, _toDisplayString(_unref(format_date)(cheque.action_at, 'date_time')), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(format_price)(cheque.total)) + " грн.", 1)
              ], 10, _hoisted_5))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (lock.isLoading)
            ? (_openBlock(), _createBlock(AppLoadingMessage, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("Loading cheque list items")
                ]),
                _: 1
              }))
            : (data.chequeLines.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.chequeLines, (line) => {
                  return (_openBlock(), _createBlock(SilpoChequeListItem, {
                    key: `cheque-list-item-${line.vendor_code}`,
                    "vendor-code": line.vendor_code,
                    name: line.name,
                    "image-url": line.image_url,
                    price: line.price,
                    quantity: line.quantity,
                    "category-id": line.category_id,
                    "total-price": line.total_price
                  }, {
                    additions: _withCtx(() => [
                      true
                        ? (_openBlock(), _createBlock(SilpoProductInfoActions, {
                            key: 0,
                            "price-chart-height": "250px",
                            "vendor-code": line.vendor_code
                          }, null, 8, ["vendor-code"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["vendor-code", "name", "image-url", "price", "quantity", "category-id", "total-price"]))
                }), 128))
              : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}
}

})